module.exports = __webpack_public_path__ + "img/banner_m.b5ed5625.jpg";